import { render, staticRenderFns } from "./addHsab2.vue?vue&type=template&id=9b20a00a"
import script from "./addHsab2.vue?vue&type=script&lang=js"
export * from "./addHsab2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports